import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentIndex: 0,
    answers: [],
    markedForReview: [],
};

const quizSlice = createSlice({
    name: "quiz",
    initialState,
    reducers: {
        answerQuestion: (state, action) => {
            const { questionId, selectedOptions } = action.payload;
            const existing = state.answers.find((a) => a.questionId === questionId);
            if (existing) {
                existing.selectedOptions = selectedOptions;
            } else {
                state.answers.push({ questionId, selectedOptions });
            }
        },
        nextQuestion: (state) => {
            state.currentIndex += 1;
        },
        previousQuestion: (state) => {
            state.currentIndex -= 1;
        },
        resetQuiz: () => initialState,
        jumpToQuestion: (state, action) => {
            state.currentIndex = action.payload;
        },
        toggleReviewMark: (state, action) => {
            const id = action.payload;
            if (state.markedForReview.includes(id)) {
                state.markedForReview = state.markedForReview.filter(qid => qid !== id);
            } else {
                state.markedForReview.push(id);
            }
        },
        prefillAnswers: (state, action) => {
            const answers = action.payload;
            state.answers = answers.map(({ questionId, answer }) => ({
                questionId: String(questionId),
                selectedOptions: answer,
            }));
        },
        clearAnswer: (state, action) => {
            const questionId = action.payload;
            state.answers = state.answers.filter((a) => a.questionId !== questionId);
        }
    },
});

export const {
    answerQuestion,
    nextQuestion,
    previousQuestion,
    resetQuiz,
    jumpToQuestion,
    toggleReviewMark,
    prefillAnswers,
    clearAnswer
} = quizSlice.actions;
export default quizSlice.reducer;
